module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.1.0-203.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/changelog/v2.1.0.md
// module id = 646
// module chunks = 375